export const moduleSlug = "CREDENTIALS_MANAGER";

export default { moduleSlug };
